export default {
    address: 'メールアドレス',
    familyName: '姓',
    givenName: '名',
    info: {
        goToYourEmailSettings:
            'この設定は<0>プロフィール</0>からご変更いただけます。',
        noteThatEditing:
            'メンバー名の変更はこれまでの書類には反映されませんのでご了承ください。（書類作成時の状態が保持されます）',
        notificationsAboutEvents:
            '<0>{{company}}</0>に関する通知は<0>{{email}}</0>に送信されます。',
        userNotifications:
            'ユーザー通知は本メールアドレス（<0>{{email}}</0>）に送信されます。',
    },
    sendingSignature: '差出人署名',
    submit: 'メンバー情報を保存',
};
